module.exports = __webpack_public_path__ + "img/USA.5a94c467.svg";